import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-54897330"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "searchDiv",
  style: {"margin-bottom":"30px"}
}
const _hoisted_2 = { class: "interviewQuestionListDiv" }
const _hoisted_3 = { class: "list-title" }

import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import router from "@/router";
import {
  listInterviewQuestionVoByPageUsingPost,
  searchQuestionVoByPageUsingPost,
} from "@/request/api/interviewQuestionController";
import { TableData } from "@arco-design/web-vue";
import { listInterviewQuestionBankVoByPageUsingPost } from "@/request/api/interviewQuestionBankController";
import TagSelect from "@/components/selecter/TagSelecter.vue";

interface Props {
  bankId: number;
  searchParams: API.InterviewQuestionQueryRequest;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InterviewQuestionTable',
  props: {
    bankId: { default: () => {
    return 0;
  } },
    searchParams: { default: () => {
    return {};
  } }
  },
  setup(__props: any) {

const props = __props;

//搜索关键词
const searchText = ref<string>("");
const searchBankText = ref<string>("");
//搜索参数
const searchParams = ref<API.InterviewQuestionQueryRequest>({
  ...props.searchParams,
  current: 1,
  pageSize: 20,
  questionBankId: props.bankId,
});
//数据
const dataList = ref<API.InterviewQuestionVO[]>([]);
const bankList = ref<API.InterviewQuestionBankVO[]>([]);
//总值
const total = ref<number>();
//加载
const loading = ref<boolean>();

/**
 * 搜索
 */
const searchEs = async () => {
  if (searchText.value == "") {
    await loadDataList();
    return;
  }
  const res = await searchQuestionVoByPageUsingPost({
    ...searchParams.value,
    searchText: searchText.value,
  });
  if (res.data.code === 0) {
    dataList.value = res.data.data?.records || [];
    total.value = res.data.data?.total || 0;
  } else {
    message.error("加载数据失败，" + res.data.message);
  }
};

/**
 * 搜索
 */
const searchMysql = async () => {
  loading.value = true;
  // 如果 questionBankId 存在，则按题库查询
  const response = await listInterviewQuestionVoByPageUsingPost({
    ...searchParams.value,
    searchText: searchText.value,
  });
  if (response.data.code === 0) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
    dataList.value.map((item, index) => {
      const current = searchParams.value.current;
      const pageSize = searchParams.value.pageSize;
      // 给标题加序号
      item.priority = index + 1 + (current - 1) * pageSize;
    });
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};
/**
 * 加载数据
 */
const loadDataList = async () => {
  loading.value = true;
  // 如果 questionBankId 存在，则按题库查询
  const response = await listInterviewQuestionVoByPageUsingPost({
    ...searchParams.value,
  });
  if (response.data.code === 0) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
    dataList.value.map((item, index) => {
      const current = searchParams.value.current;
      const pageSize = searchParams.value.pageSize;
      // 给标题加序号
      item.priority = index + 1 + (current - 1) * pageSize;
    });
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};

const loadBankList = async () => {
  const response = await listInterviewQuestionBankVoByPageUsingPost({
    searchText: searchBankText.value,
  });
  if (response.data.code === 0) {
    bankList.value = response.data.data?.records || [];
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
};
/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadDataList();
});

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 点击题目
 */
const click = (record: TableData) => {
  if (props.bankId == 0) {
    router.push({
      path: `/interviewQuestion/detail/${record.id}`,
    });
  } else {
    router.push({
      path: `/interviewQuestion/detail/${props.bankId}/${record.id}`,
    });
  }
};

const columns = [
  {
    title: "题目",
    dataIndex: "priority",
    slotName: "priority",
    sortable: {
      sortDirections: ["ascend", "descend"],
    },
  },
  {
    title: "VIP",
    slotName: "needVip",
    dataIndex: "needVip",
    width: 100,
  },
  {
    title: "标签",
    slotName: "tags",
    dataIndex: "tags",
    width: 300,
  },
];

return (_ctx: any,_cache: any) => {
  const _component_icon_search = _resolveComponent("icon-search")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (props.bankId == 0)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            layout: "inline",
            "auto-label-width": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { style: {"margin":"0 auto"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_search, {
                    placeholder: "你想知道什么面试题",
                    "search-button": "",
                    modelValue: searchText.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
                    onSearch: searchMysql,
                    onKeyup: _withKeys(searchMysql, ["enter"])
                  }, {
                    "button-icon": _withCtx(() => [
                      _createVNode(_component_icon_search)
                    ]),
                    "button-default": _withCtx(() => [
                      _createTextVNode(" 搜索")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { flex: "auto" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, { size: "large" }, {
                  default: _withCtx(() => [
                    (props.bankId == 0)
                      ? (_openBlock(), _createBlock(_component_a_select, {
                          key: 0,
                          placeholder: "请选择题库",
                          "allow-clear": "",
                          "allow-search": "",
                          onClick: loadBankList,
                          onClear: _cache[1] || (_cache[1] = ($event: any) => (searchParams.value.questionBankId = null))
                        }, {
                          prefix: _withCtx(() => [
                            _createTextVNode("题库：")
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bankList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_a_option, {
                                key: item.id,
                                onClick: ($event: any) => (searchParams.value.questionBankId = item.id)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_select, {
                      "allow-clear": "",
                      modelValue: searchParams.value.needVip,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.needVip) = $event)),
                      style: {"width":"150px"}
                    }, {
                      prefix: _withCtx(() => [
                        _createTextVNode("会员专属：")
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_option, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("是")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_option, { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("否")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(TagSelect, {
                      modelValue: searchParams.value.tags,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchParams.value.tags) = $event)),
                      placeholder: "可选5个标签，可搜索",
                      prefix: "标签:",
                      limit: 5
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (props.bankId != 0)
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 0,
                  flex: "240px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createTextVNode(" 题目: "),
                        _createVNode(_component_a_input_search, {
                          style: {"max-width":"200px"},
                          placeholder: "你想知道什么面试题",
                          modelValue: searchText.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchText).value = $event)),
                          onSearch: searchMysql,
                          onKeyup: _withKeys(searchMysql, ["enter"])
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_a_table, {
        data: dataList.value,
        loading: loading.value,
        bordered: false,
        columns: columns,
        pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
      },
        onPageChange: onPageChange,
        onRowClick: click
      }, {
        priority: _withCtx(({ record }) => [
          _createVNode(_component_a_typography_text, {
            type: "primary",
            style: {"font-size":"16px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(record.priority) + ". " + _toDisplayString(record.title), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        tags: _withCtx(({ record }) => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tagList, (tag) => {
                return (_openBlock(), _createBlock(_component_a_tag, { key: tag }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tag), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 2
          }, 1024)
        ]),
        needVip: _withCtx(({ record }) => [
          (record.needVip == 1)
            ? (_openBlock(), _createBlock(_component_a_tag, {
                key: 0,
                color: "#ffb400",
                style: {"margin-left":"-5px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" VIP ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data", "loading", "pagination"])
    ])
  ], 64))
}
}

})